import { rebuildFormArray } from '@shared/helpers/form.helper';
import { MyAltroAllegato, MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { FormBuilder, FormGroup } from '@angular/forms';

export const buildAllegatiFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const allegati = myVerbale.my_AltriAllegati?.my_AltroAllegato ?? [];
    rebuildFormArray(fb, allegati, form, 'my_AltriAllegati.my_AltroAllegato', buildAltroAllegatoFormGroup);
};

export const buildAltroAllegatoFormGroup = (fb: FormBuilder, item?: MyAltroAllegato): FormGroup => {
    return fb.group({
        my_AltroAllegatoElement: item?.my_AltroAllegatoElement,
        my_AltroAllegatoElementDescrizione: item?.my_AltroAllegatoElementDescrizione,
    });
};
